import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SuccessCard = styled.div`
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  border-radius: 16px;
  padding: 24px;
  text-align: center;
  
  .icon {
    font-size: 48px;
    margin-bottom: 12px;
  }
  
  h3 {
    margin: 0 0 8px 0;
    color: #065f46;
    font-size: 20px;
    font-weight: 700;
  }
  
  p {
    margin: 0;
    color: #047857;
    font-size: 14px;
  }
`;

export const SummaryCard = styled.div`
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
`;

export const SummaryHeader = styled.div`
  padding: 14px 16px;
  background: linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%);
  display: flex;
  align-items: center;
  gap: 10px;
  
  h4 {
    margin: 0;
    color: white;
    font-size: 14px;
    font-weight: 600;
  }
`;

export const SummaryBody = styled.div`
  padding: 16px;
`;

export const SummaryRow = styled.div<{ highlight?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f1f5f9;
  
  &:last-child {
    border-bottom: none;
  }
  
  ${props => props.highlight && `
    background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
    margin: 12px -16px -16px -16px;
    padding: 16px;
    border-radius: 0 0 16px 16px;
    border-bottom: none;
  `}
`;

export const SummaryLabel = styled.span<{ bold?: boolean }>`
  font-size: ${props => props.bold ? '16px' : '14px'};
  font-weight: ${props => props.bold ? '700' : '500'};
  color: ${props => props.bold ? '#1e293b' : '#64748b'};
`;

export const SummaryValue = styled.span<{ highlight?: boolean; showValue?: boolean }>`
  font-size: ${props => props.highlight ? '20px' : '14px'};
  font-weight: ${props => props.highlight ? '700' : '600'};
  color: ${props => {
    if (!props.showValue) return '#94a3b8';
    return props.highlight ? '#10b981' : '#1e293b';
  }};
`;

export const ItemsPreview = styled.div`
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
`;

export const ItemsHeader = styled.div`
  padding: 14px 16px;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  h4 {
    margin: 0;
    color: white;
    font-size: 14px;
    font-weight: 600;
  }
  
  span {
    background: rgba(255, 255, 255, 0.2);
    color: white;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
  }
`;

export const ItemsList = styled.div`
  padding: 12px 16px;
  max-height: 200px;
  overflow-y: auto;
`;

export const ItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;
  
  &:last-child {
    border-bottom: none;
  }
`;

export const ItemInfo = styled.div`
  flex: 1;
  min-width: 0;
  
  .nome {
    font-size: 13px;
    font-weight: 500;
    color: #1e293b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .meta {
    font-size: 11px;
    color: #64748b;
    margin-top: 2px;
  }
`;

export const ItemValor = styled.span<{ showValue?: boolean }>`
  font-size: 13px;
  font-weight: 600;
  color: ${props => props.showValue ? '#10b981' : '#94a3b8'};
  white-space: nowrap;
  margin-left: 12px;
`;

export const BtnFixed = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background: white;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  gap: 12px;
  z-index: 100;
`;

export const Button = styled.button<{ variant?: 'primary' | 'secondary' | 'danger' }>`
  flex: 1;
  padding: 14px 20px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  ${props => {
    switch (props.variant) {
      case 'primary':
        return `
          background: linear-gradient(135deg, #10b981 0%, #059669 100%);
          border: none;
          color: white;
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
          
          &:disabled {
            background: #94a3b8;
            box-shadow: none;
          }
          
          &:hover:not(:disabled) {
            box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
          }
        `;
      case 'danger':
        return `
          background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
          border: none;
          color: white;
          
          &:hover {
            box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
          }
        `;
      default:
        return `
          background: white;
          border: 2px solid #e2e8f0;
          color: #475569;
          
          &:hover {
            border-color: #94a3b8;
          }
        `;
    }
  }}
`;

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  
  .spinner {
    width: 48px;
    height: 48px;
    border: 4px solid #e2e8f0;
    border-top-color: #10b981;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin-bottom: 16px;
  }
  
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  
  p {
    margin: 0;
    font-size: 16px;
    color: #475569;
    font-weight: 500;
  }
`;

